import React, { useEffect, useState } from "react";

import { MainBody, OverlayLoader, PageTitle } from "components/core";
import { SideNav } from "components";
import GmcForm from "components/PlanSetup/GmcForm";
import { WidthLimiter } from "./styles";
import http from "services/httpService";

const GmcSetup = () => {
  // gmc details
  const [gmcDetails, setGmcDetails] = useState();
  // loading state
  const [isLoading, setIsLoading] = useState(true);

  // fetch GMC setup details
  const fetchGmc = async () => {
    try {
      setIsLoading(true);
      const { data } = await http.get("/business/get_gmc_plan_setup_details/");
      setGmcDetails(data);
      if(data.tpas) {
        localStorage.setItem("tpa_details", JSON.stringify(data.tpas))
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      await fetchGmc();
    })();
  }, []);
  return (
    <section>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <MainBody>
            <WidthLimiter>
              <PageTitle title="Setup Group Health Insurance" />
              <GmcForm details={gmcDetails} />
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </section>
  );
};

export default GmcSetup;
